import { OpenInNew } from 'components/icons';
import { cn } from 'utils/cn';

/** The link class shared by the "open elsewhere" links: small, bold, link-coloured, glyph after the label. */
export const EXTERNAL_LINK_CLASS =
    'text-link flex cursor-pointer items-center gap-1 text-xs font-semibold no-underline hover:underline';

export default function ExternalIntegrationLink({
    href,
    label,
    showIcon = true,
    className,
}: {
    href: string;
    label: string;
    showIcon?: boolean;
    className?: string;
}) {
    return (
        <div className={cn('self-center', className)}>
            <a href={href} target="_blank" rel="noopener noreferrer" className={EXTERNAL_LINK_CLASS}>
                {label}
                {showIcon && <OpenInNew fontSize="small" />}
            </a>
        </div>
    );
}
